import { IDirective, IDirectiveFactory } from "angular";

export class ListGrid implements IDirective {
  public scope = {
    contentItems: "=",
    columns: "=",
  };
  public restrict = "E";
  public templateUrl = require("../views/list-grid.jade");

  public static factory(): IDirectiveFactory {
    const directive = () => new ListGrid();
    directive.$inject = [];
    return directive;
  }
}
